import {combineReducers} from 'redux';
import * as storage from 'redux-storage';
// import posts from './posts';
import projects from './projects';
import auth from './auth';
import events from './events';
import {ProjectData, EventData} from '../interface';

export interface CombinedState {
    // posts: {isLoading: Boolean, numberOfPages:number, currentPage:number, posts: PostData[], post:PostData},
    auth:{isLoading: Boolean, loggedIn: Boolean, authData: any, errors: any},
    projects: {isLoading: Boolean, numberOfPages:number, currentPage:number, projects: ProjectData[], project:ProjectData}
    events: {isLoading: Boolean, numberOfPages:number, currentPage:number, events: EventData[], event:EventData}
  }

export default storage.reducer(combineReducers<CombinedState>({
    // posts:posts,
    auth:auth,
    projects:projects, 
    events: events
}));